import { Right } from "neetoicons";
import { Dropdown } from "neetoui";
import { useTranslation } from "react-i18next";

const MenuButton = ({ ...otherProps }) => {
  const { t } = useTranslation();
  const { MenuItem } = Dropdown;

  return (
    <MenuItem.Button
      className="neeto-molecules-menu-sublist__item-btn"
      data-testid="product-switcher-button"
      label={t("neetoMolecules.sidebar.productSwitcher")}
      style="text"
      suffix={<Right className="rtl:scale-x-[-1]" size={18} />}
      {...otherProps}
    >
      {t("neetoMolecules.sidebar.productSwitcher")}
    </MenuItem.Button>
  );
};

export default MenuButton;
